export type KeyDeck = "home" | "mixed" | "full";

const HOME = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];
const MIXED = [...HOME, "q", "w", "e", "r", "u", "i", "o", "p"];
const FULL = [...MIXED, "z", "x", "c", "v", "b", "n", "m", "t", "y"];

const DECKS: Record<KeyDeck, string[]> = { home: HOME, mixed: MIXED, full: FULL };

export function poolFor(deck: KeyDeck): string[] {
  return DECKS[deck];
}

export function assignKeys(
  count: number,
  deck: KeyDeck,
  rng = Math.random,
  locked?: string[],
): string[] {
  if (count < 1) throw new Error("count must be positive");
  if (locked && locked.length === count) return [...locked];
  const pool = [...poolFor(deck)];
  if (count > pool.length) throw new Error("not enough keys in deck");
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, count);
}

export function normalizeKey(eventKey: string): string {
  if (eventKey === " ") return "space";
  return eventKey.length === 1 ? eventKey.toLowerCase() : eventKey.toLowerCase();
}
